export interface ScrapedUrlGq {
  url: string;
  pageHttpStatus?: number;
  startScrapeTime?: string;
  endScrapeTime?: string;
}

export const ScrapedUrlGqProps = `
    url
    pageHttpStatus
    startScrapeTime
    endScrapeTime
`;
